import router, { constantRoutes, rootRouter, dynamicRoutes } from "@/router";
import { defineStore } from "pinia";

// 匹配views里面所有的.vue文件
const modules = require.context("./../../views", true, /\.vue$/);

const usePermissionStore = defineStore("permission", {
  state: () => ({
    routes: [],
    addRoutes: [],
    admin: false,
    defaultRoutes: [], // 默认路由
    topbarRouters: [], // 顶部路由
    sidebarRouters: [], // 侧路由     路由目前只使用了这个
    routerPermission: {}, // 路由权限
    buttonPermission: {}, // 按钮权限
    permissionTrees: [], //权限树
  }),
  actions: {
    setRoutes(routes) {
      this.addRoutes = routes;
      this.routes = constantRoutes.concat(routes);
    },
    setDefaultRoutes(routes) {
      this.defaultRoutes = constantRoutes.concat(routes);
    },
    setTopbarRoutes(routes) {
      this.topbarRouters = routes;
    },
    setSidebarRouters(routes) {
      this.sidebarRouters = routes;
    },
    setRolesPermission(rolesPermission) {
      this.rolesPermission = rolesPermission;
    },
    setRouterPermission(routerPermission) {
      this.routerPermission = routerPermission;
    },
    setButtonPermission(buttonPermission) {
      this.buttonPermission = buttonPermission;
    },
    removeData() {
      // 移除数据
      this.routes = [];
      this.addRoutes = [];
      this.admin = false;
      this.defaultRoutes = [];
      this.topbarRouters = [];
      this.sidebarRouters = [];
      this.routerPermission = {}; // 路由权限
      this.buttonPermission = {}; // 按钮权限
      this.rolesPermission = {}; // 角色权限
    },
    generateRoutes(operationData, roleEntities, admin) {
      this.admin = admin;
      return new Promise((resolve) => {
        const {
          routers,
          sidebarRouters,
          rolesPermission,
          routerPermission,
          buttonPermission,
        } = filterDynamicRoutes(
          operationData,
          roleEntities,
          dynamicRoutes,
          admin
        );
        routers.forEach((route) => {
          router.addRoute(route);
        });
        this.setRoutes(routers);
        this.setSidebarRouters(sidebarRouters);
        this.setRolesPermission(rolesPermission);
        this.setRouterPermission(routerPermission);
        this.setButtonPermission(buttonPermission);
        resolve();
      });
    },
  },
});

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(
  operationData,
  roleEntities,
  routes,
  admin
) {
  const noLayoutRoutes = [];
  const rolesPermission = getRolesPermission(roleEntities);
  const { routerPermission, buttonPermission } =
    getRouterAndButtonPermission(operationData);

  const sidebarRouters = iterationFilterDynamicRoutes(
    routerPermission,
    rolesPermission,
    noLayoutRoutes,
    routes,
    admin
  );
  rootRouter.children = rootRouter.children.concat(sidebarRouters);
  return {
    routers: [...noLayoutRoutes, rootRouter],
    sidebarRouters,
    rolesPermission,
    routerPermission,
    buttonPermission,
  };
}

/**
 * 迭代遍历路由
 * @param {*} routes
 */
function iterationFilterDynamicRoutes(
  routerPermission, // 路由权限
  rolesPermission, // 角色权限
  noLayoutRoutes, // 不在布局中的路由
  routes,
  admin = false
) {
  const sidebarRouters = [];
  routes.forEach((route) => {
    if (
      routerPermission[route.name] ||
      admin ||
      (route.roles && hasRolePermission(rolesPermission, route.roles))
    ) {
      if (route.children) {
        route.children = iterationFilterDynamicRoutes(
          routerPermission,
          rolesPermission,
          noLayoutRoutes,
          route.children,
          admin
        );
      }
      if (route.hidden) {
        noLayoutRoutes.push(route);
      } else {
        sidebarRouters.push(route);
      }
    }
  });
  return sidebarRouters;
}

/**
 * 获取按钮权限和路由权限
 * @param {*} operationData
 */
function getRouterAndButtonPermission(operationData) {
  const routerPermission = {};
  const buttonPermission = {};

  operationData.forEach((item) => {
    if (item.operationType === "F") {
      buttonPermission[item.operationCode] = true;
    } else {
      routerPermission[item.operationCode] = true;
    }
  });
  return {
    routerPermission,
    buttonPermission,
  };
}

/**
 * 获取角色权限
 * @param {*} roleEntities
 * @returns
 */
function getRolesPermission(roleEntities) {
  const rolesPermission = {};
  roleEntities &&
    roleEntities instanceof Array &&
    roleEntities.forEach((item) => {
      rolesPermission[item.roleCode] = true;
    });
  return rolesPermission;
}

/**
 * 判断是否包含角色权限
 * @param {*} rolePermission
 * @param {*} route
 */
function hasRolePermission(rolePermission, roles) {
  let hasPermission = false;
  roles &&
    roles instanceof Array &&
    roles.forEach((item) => {
      if (item === "all" || rolePermission[item]) {
        hasPermission = true;
      }
    });
  return hasPermission;
}

export default usePermissionStore;
